import { urlWithParams } from '@marketplace-web/shared/url-util'

export const MEMBER_PROFILE_URL = (id: string | number, closetPromotionPrecheckout?: boolean) =>
  urlWithParams(`/member/${id}`, { cp_precheckout: closetPromotionPrecheckout })
export const RATE_LIMITED_URL = '/rate-limited'
